import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList'

export const ClosureDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="CLOSURE" parentEntityId={entityObj.id} /> },
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}